@let currentAdminValue = currentAdmin();
<div class="config-container">
  <rt-heading class="item">{{ currentAdminValue?.firstName }}</rt-heading>
  <div class="auth-token-input item" layout>
    <rt-input placeholder="auth token" [formControl]="authTokenControl" type="password" />
    <rt-button variant="tertiary" margin-left-small-x (click)="onAuthTokenApply()">Apply</rt-button>
  </div>
  <rt-select
    [options]="(companies$ | async)!"
    [value]="(currentCompany$ | async)?.id!"
    (valueChange)="onCompanySelect($event)"
    class="company-picker item"
    margin-right-small-x
  />
  @for (route of routes; track trackByIndex($index, route); let last = $last) {
    <a margin-lr-small-x [routerLink]="route.path">{{ route.path }}</a>
  }
</div>
<div class="playground-container">
  <aside></aside>
  <main rtScrollable>
    <rtc-detached-router-outlet />
  </main>
</div>
